import React from 'react';
import { DropZone } from '@measured/puck';
import { resolveBackgroundColor, backgroundColorOptions } from './theme/colors';

// Container component for consistent spacing, max-width, and max-height
const ContainerComponent = ({
  maxWidth = '1200px',
  maxHeight = 'none',
  padding = '24px',
  backgroundColor = 'transparent',
  centerContent = true
}) => {
  const resolvedMaxWidth = maxWidth === '100%' ? '100%' : maxWidth;
  const paddingValue = padding;
  const shouldCenter = centerContent !== false;
  const resolvedBackground = resolveBackgroundColor(backgroundColor, 'transparent');

  // Get the maxHeight style value
  const getMaxHeightStyle = () => {
    return maxHeight === 'none' ? {} : { maxHeight: maxHeight };
  };

  return (
    <div
      className={resolvedBackground.className}
      style={{
        boxSizing: 'border-box',
        maxWidth: resolvedMaxWidth,
        marginLeft: shouldCenter ? 'auto' : undefined,
        marginRight: shouldCenter ? 'auto' : undefined,
        padding: paddingValue,
        width: '100%',
        overflow: maxHeight !== 'none' ? 'auto' : 'visible',
        ...getMaxHeightStyle(),
        ...resolvedBackground.style
      }}
    >
      <DropZone
        zone="container-zone"
        style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
      />
    </div>
  );
};

export const Container = {
  fields: {
    maxWidth: {
      type: 'select',
      label: 'Maximale Breite',
      options: [
        { label: 'Schmal (800px)', value: '800px' },
        { label: 'Mittel (1000px)', value: '1000px' },
        { label: 'Breit (1200px)', value: '1200px' },
        { label: 'Sehr breit (1400px)', value: '1400px' },
        { label: 'Vollbreite (100%)', value: '100%' }
      ]
    },
    maxHeight: {
      type: 'select',
      label: 'Maximale Höhe',
      options: [
        { label: '300px', value: '300px' },
        { label: '400px', value: '400px' },
        { label: '500px', value: '500px' },
        { label: '600px', value: '600px' },
        { label: '700px', value: '700px' },
        { label: '800px', value: '800px' },
        { label: '1000px', value: '1000px' },
        { label: '1200px', value: '1200px' },
        { label: '1500px', value: '1500px' },
        { label: '2000px', value: '2000px' },
        { label: 'Keine Begrenzung', value: 'none' }
      ]
    },
    padding: {
      type: 'select',
      label: 'Innenabstand',
      options: [
        { label: 'Klein (16px)', value: '16px' },
        { label: 'Mittel (24px)', value: '24px' },
        { label: 'Groß (32px)', value: '32px' },
        { label: 'Sehr groß (48px)', value: '48px' }
      ]
    },
    backgroundColor: {
      type: 'select',
      label: 'Hintergrundfarbe',
      options: backgroundColorOptions()
    },
    centerContent: {
      type: 'radio',
      label: 'Inhalt zentrieren',
      options: [
        { label: 'Ja', value: true },
        { label: 'Nein', value: false }
      ]
    }
  },
  defaultProps: {
    maxWidth: '1200px',
    maxHeight: 'none',
    padding: '24px',
    backgroundColor: 'transparent',
    centerContent: true
  },
  render: ContainerComponent
};
